module.exports = require('../site_settings')


// WEBPACK FOOTER //
// ./assets/js/shared/util/error/config.coffee